import { useQueryCache } from "@pinia/colada";
import { callWithNuxt, createError, defineNuxtPlugin, showError } from "#app";

/**
 * Colada keeps client-side query errors in state, so a 404 renders the page's own error block
 * instead of Nuxt's error page. SSR reaches the error boundary on its own.
 */
export default defineNuxtPlugin((nuxtApp) => {
  useQueryCache().$onAction(({ onError }) => {
    onError((error) => {
      if (
        error instanceof Error &&
        "statusCode" in error &&
        error.statusCode === 404
      ) {
        void callWithNuxt(nuxtApp, () =>
          showError(
            createError({
              statusCode: 404,
              data: { clientSideNavigation: true },
            }),
          ),
        );
      }
    });
  });
});
